import {combineReducers} from 'redux';
import shops from './shops.js';
import categories from './categories.js';
import cart from './cart.js';
import delivery from './delivery.js';
import contactus from './contactus.js';

export default combineReducers({
  shops: shops,
  categories: categories,
  delivery: delivery,
  cart: cart,
  contactus: contactus
})


// WEBPACK FOOTER //
// ./src/reducers/index.js